import { Link } from 'react-router-dom';
import styled from 'styled-components';
import PageSeo from '../components/PageSeo';

export default function NotFound() {
  return (
    <Page>
      <PageSeo
        title="Página no encontrada | NIDO"
        description="La página que buscás no existe o ya no está disponible."
        path={window.location.pathname}
        robots="noindex,follow"
      />
      <span>ERROR 404</span>
      <h1>Esta página no está disponible.</h1>
      <p>Podés volver al buscador para encontrar propiedades activas en Cuyo.</p>
      <Link to="/buscar">Buscar propiedades</Link>
    </Page>
  );
}

const Page = styled.main`
  min-height:65vh;display:grid;place-content:center;text-align:center;padding:70px 22px;background:#f7f5ef;color:#29474f;
  span{color:#c66f4e;font-size:12px;font-weight:850;letter-spacing:.18em}
  h1{max-width:760px;margin:18px auto;font-size:clamp(42px,7vw,82px);line-height:.95;letter-spacing:-.055em}
  p{color:#68777b;font-size:17px}
  a{justify-self:center;margin-top:18px;padding:15px 22px;border-radius:999px;background:#29474f;color:#fff;text-decoration:none;font-weight:800}
`;
